import { ManagerSpotlightWizard } from '@/components/dealPipeline-page/managerSpotlightWizard-page';
import useRefresh from '@/hooks/use-refresh';
import { Helmet as Head } from 'react-helmet';

const ManagerSpotlightWizardPage = () => {
  useRefresh();
  return (
    <>
      <Head>
        <title>Manager Spotlight Wizard</title>
      </Head>
      <ManagerSpotlightWizard />
    </>
  );
};

export default ManagerSpotlightWizardPage;
